import { Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { CheckCircleIcon, ExclamationTriangleIcon } from "@heroicons/react/24/solid";
import { Fragment, useState } from "react";
import type { FunctionComponent } from "react";

const Alert: FunctionComponent<{
  message?: string;
  typeAlert?: string;
}> = (props) => {
  const [show, setShow] = useState(true);
  return (
    <div
      aria-live="assertive"
      className="pointer-events-none fixed inset-0 z-10 mx-auto flex max-w-7xl items-start px-4 py-6 sm:p-6 sm:px-6 lg:px-8"
    >
      <div className="mt-16 w-full space-y-4 md:right-6 md:float-right md:ml-auto md:w-5/12">
        {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
        <Transition
          show={show}
          as={Fragment}
          enter="transform ease-out duration-300 transition"
          enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          enterTo="translate-y-0 opacity-100 sm:translate-x-0"
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="pointer-events-auto w-full max-w-full overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
            <div className="p-3 md:p-4">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  {props.typeAlert === "Error" ? (
                    <ExclamationTriangleIcon className="h-6 w-6 text-red-400" aria-hidden="true" />
                  ) : (
                    <CheckCircleIcon className="h-6 w-6 text-green-400" aria-hidden="true" />
                  )}
                </div>
                <div className="ml-3 w-0 flex-1">
                  <p className="align-middle text-sm font-bold text-gray-900">
                    {props.typeAlert === "Error" ? "Error" : "Success"}
                    <span className="mt-1 pl-1.5 text-sm font-light text-gray-700">{props.message}</span>
                  </p>
                </div>
                <div className="ml-4 flex flex-shrink-0">
                  <button
                    type="button"
                    className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    onClick={() => {
                      setShow(false);
                    }}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Transition>
      </div>
    </div>
  );
};

export default Alert;
